import { queryOptions, useQuery } from '@tanstack/react-query';

import type { FamilyByStudentResponse } from '~entities/family/model/family.type';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getFamilyByStudent = async (studentId: string) => {
  const response = await baseAPI.get<FamilyByStudentResponse>(
    `/v2/families/by-student/${studentId}`,
  );
  return response.data;
};

export const getFamilyByStudentOptions = (studentId?: string) =>
  queryOptions({
    queryKey: [KEYS.FAMILY_BY_STUDENT, studentId],
    queryFn: () => getFamilyByStudent(studentId!),
    staleTime: 1000 * 60 * 2,
    enabled: !!studentId,
  });

export const useGetFamilyByStudent = (studentId?: string) => {
  return useQuery(getFamilyByStudentOptions(studentId));
};
